/*
 * @Author: edvardchen
 * @Date:   2016-08-19 22:39:29
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2018-09-13 16:04:37
 */

const MTT = {};
exports.MTT = MTT;

MTT.EContentFieldFlag = {
  ECFF_TEXT: 0,
  ECFF_BR: 1,
  ECFF_IMG: 2,
  ECFF_STRONG: 3,
  ECFF_IMGTEXT: 4,
  ECFF_VIDEO: 5,
  ECFF_AUDIO: 6,
  ECFF_LINK: 7,
  ECFF_MTTTAG: 8,
  ECFF_VIDEO_IFRAME: 9,
  ECFF_ZH_AUTHOR: 10,
  ECFF_ZH_AUTHOR_URL: 11,
  ECFF_ZH_AUTHOR_DETAIL: 12,
  ECFF_BOOK_INFO: 13,
  ECFF_ANCHOR_INFO: 14
};



//////////////////
// WEBPACK FOOTER
// ./src/jce/MTT4ServerProxy.js
// module id = 4
// module chunks = 0